import React, {useEffect, useState} from 'react';
import {useApiCreateAdminConfigs, useApiSearchAdminConfigs} from "@/api/config";
import FreeBox from "@/components/box/freeBox";
import {Button, Input} from "antd";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";
import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";
import TextArea from "antd/lib/input/TextArea";
import RenderLoading from "@/components/render-if-loading";


function AdminRefundConfig(props) {
    const [refundTerms, setRefundTerms] = useState('')

    const {mutate: updateConfigsMutation} = useApiCreateAdminConfigs();

    const {data: configData, isLoading: isLoadingConfigs, refetch} = useApiSearchAdminConfigs({});

    useEffect(() => {
        if (configData && configData?.data && configData?.data?.data?.length > 0) {
            configData?.data?.data?.forEach((item) => {
                if (item?.category === 'system' && item?.key === 'refund_terms') {
                    setRefundTerms(item?.value);
                }
            })
        }
    }, [configData]);

    function handleUpdateConfigsMutation() {
        updateConfigsMutation({
            'category': 'system',
            'key': 'refund_terms',
            'value': refundTerms,
        }, {
            onSuccess: (res) => {
                ApiHandleSuccessMessage(res)
            },
            onError: (err) => {
                ApiHandleErrorMessage(err)
            }
        })
    }

    const onChange = value => {
        setRefundTerms(value);
    };

    return (
        <AdminLayout pageTitle={'تنظیمات بازگشت وجه'} backTo={URLS.admin.setting.dashboard}>

            <div>
                <FreeBox>
                    <RenderLoading loading={isLoadingConfigs} skeleton={true}>

                        <label className={'m-2'} htmlFor="refundTerms">پیام قبل از ثبت درخواست بازگشت وجه</label>

                        <Input.TextArea
                            rows={10}
                            placeholder={'متن شرایط و وقوانین بازگشت وجه را اینجا بنویسید'}
                            onChange={(e) => setRefundTerms(e.target.value)}
                            value={refundTerms}
                        />
                        <div className={'text-gray-400'}>
                            <span>متن شرایط و وقوانین بازگشت وجه را اینجا بنویسید</span>
                        </div>

                        <div className="flex justify-end mt-2">
                            <Can permission={PermList.SETTINGS_EDIT}>
                                <Button onClick={handleUpdateConfigsMutation} type={'primary'}>ذخیره</Button>
                            </Can>
                        </div>
                    </RenderLoading>
                </FreeBox>
            </div>
        </AdminLayout>
    );
}

export default AdminRefundConfig;